const assetPath = process.env.ASSET_PREFIX ?? '';

export const valueProps = [
    {
        id: 'personal-plan-0',
        heading: gettext('Build in-demand career skills'),
        content: gettext(
            'Stay on top of the latest in-demand topics in business, AI, productivity, data science, web development, cloud computing, leadership, design, digital marketing, and more.',
        ),
        imgSrc: {
            mobileSrc: `${assetPath}/staticx/udemy/images/value-plan/feature-1-1196x658.png`,
            desktopSrc: `${assetPath}/staticx/udemy/images/value-plan/feature-1-1196x658.png`,
            desktopSrc2x: `${assetPath}/staticx/udemy/images/value-plan/feature-1-1196x658.png`,
        },
    },
    {
        id: 'personal-plan-1',
        heading: gettext('Go beyond the course'),
        content: gettext(
            'Get real-world guidance and practice when you need it with Udemy AI Assistant, AI Role Play simulations, technical labs, and coding exercises.',
        ),
        imgSrc: {
            mobileSrc: `${assetPath}/staticx/udemy/images/value-plan/feature-2-1196x658.png`,
            desktopSrc: `${assetPath}/staticx/udemy/images/value-plan/feature-2-1196x658.png`,
            desktopSrc2x: `${assetPath}/staticx/udemy/images/value-plan/feature-2-1196x658.png`,
        },
    },
    {
        id: 'certification',
        heading: gettext('Validate your skills'),
        content: gettext(
            'Prep for industry-leading certifications employers love like AWS, Microsoft, CompTIA, PMI, and more with comprehensive, exam-aligned courses and savings on vouchers for select certifications.',
        ),
        imgSrc: {
            mobileSrc: `${assetPath}/staticx/udemy/images/value-plan/feature-3.webp`,
            desktopSrc: `${assetPath}/staticx/udemy/images/value-plan/feature-3.webp`,
            desktopSrc2x: `${assetPath}/staticx/udemy/images/value-plan/feature-3.webp`,
        },
    },
    {
        id: 'starter-plan-0',
        heading: gettext('Stay current'),
        content: gettext(
            'Get affordable access to a wide range of top-rated courses from real-world experts.',
        ),
        imgSrc: {
            mobileSrc: `${assetPath}/staticx/udemy/images/value-plan/feature-4.webp`,
            desktopSrc: `${assetPath}/staticx/udemy/images/value-plan/feature-4.webp`,
            desktopSrc2x: `${assetPath}/staticx/udemy/images/value-plan/feature-4.webp`,
        },
    },
];
